angular.module("preventivoRiscatto.components", []).component("preventivoRiscatto", {
    templateUrl: "ng/components/riscattoAnticipato/preventivoRiscatto/preventivoRiscatto.view.html",
    bindings: {
        richiestePostVendita: "<",
        numContratto: "<",
        numModulo: "<",
        postVendita: "<",
        validateComponent: "&"
    },
    controllerAs: "preventivoRiscattoCtrl",
    controller: function PreventivoRiscatto(
        $arcService,
        $download
    ) {
        var self = this;

        var initProvince = function () {
            self.supportModel.provinceType = $rootScope.comuniMap
                .map(function (comune) {
                    return comune.sigla;
                })
                .filter(function (siglaComune) {
                    return siglaComune != "";
                })
                .sort()
                .reduce(function (result, nextItem) {
                    return result.includes(nextItem) ? result : result.concat(nextItem);
                }, []);
        };

        self.$onInit = function () {
            initProvince();
            self.supportModel = {
                restIsPending: false,
                preventiveAccepted: false,
                preventivePrinted: false,
                restDownloadRunning: false,
                listOfDocumentDownload: [],
                initialIndex: 0
            }
            self.getDocs()
            checkValidityComponent();
        }

        self.handleChange = function (property, value) {
            checkValidityComponent();
        }

        self.getDocs = function () {
            self.supportModel.restDownloadRunning = true;
            $arcService.getKeyPrevEstinzione(self.richiestePostVendita)
                .then(function (response) {
                    self.supportModel.listOfDocumentDownload = response.listDocuments;
                    self.supportModel.restDownloadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.supportModel.restDownloadRunning = false;
                })
        }

        self.printPreventive = function () {
            self.supportModel.restIsPending = true;
            if (self.supportModel.listOfDocumentDownload.length != 0) {
                self.generdownloadDoc(self.supportModel.listOfDocumentDownload[0])
                self.supportModel.preventivePrinted = true;
            } else {
                console.log("Il rest di stampa non ha documenti da stampare. Per evitare errori in console ho piazzato questo messaggio");
                self.supportModel.preventivePrinted = true;
            }
        }

        self.generdownloadDoc = function (file) {
            var input = {
                downloadKey: file.downloadKey
            }
            var url = "/uni/downloadDocPv/service-infos/";
            $download.getGenericDownload(url, input)
                .then(function (response) {

                    self.supportModel.restIsPending = false;
                    checkValidityComponent();
                })
                .catch(function (error) {
                    console.log(error)
                    self.supportModel.restIsPending = false;
                    checkValidityComponent();
                })
        };


        self.check = function () {
            self.supportModel.preventiveAccepted = !self.supportModel.preventiveAccepted;
            checkValidityComponent();
        }

        var checkValidityComponent = function () {
            if (!self.richiestePostVendita.metadata.riscattoAnticipato.riscattoTerzo) {
                if (self.supportModel.preventiveAccepted && self.supportModel.preventivePrinted) {
                    self.validateComponent({
                        validity: true
                    });
                } else {
                    self.validateComponent({
                        validity: false
                    });
                }
            } else {
                if (self.supportModel.preventiveAccepted && self.supportModel.preventivePrinted &&
                    self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante.email &&
                    self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante.telefono &&
                    self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante.description) {
                    self.validateComponent({
                        validity: true
                    });
                } else {
                    self.validateComponent({
                        validity: false
                    });
                }
            }
        }
    }
})